/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable view-models/no-unused-meta */
/* eslint-disable react/prop-types */
// TODO: remove view-models/no-unused-meta and eslint-disable react/prop-types
import React from 'react';
import LinkBase from 'components/models/link-base';
import Icon from 'components/icon';
import PropTypes from 'prop-types';
import cn from 'classnames';

// eslint-disable-next-line view-models/no-errors
export const sizes = {
  normal: 'normal',
  small: 'small',
};

// eslint-disable-next-line view-models/no-errors
export const themes = {
  default: 'default',
  lightHover: 'light-hover',
  greenHover: 'green-hover',
};

const LinkButton = ({
  className,
  openInNewTab = false,
  url,
  size = sizes.normal,
  theme = themes.normal,
  text,
  tabindex,
  isActive,
  leftIconName,
  iconName,
  onClick,
}) => {
  const RootTag = url ? 'a' : 'button';

  return (
    <RootTag
      href={url}
      className={cn('link-button', {
        [className]: className,
        'link-button_size-small': size === sizes.small,
        [`link-button_theme-${theme}`]: theme,
        'link-button_active': isActive,
      })}
      target={openInNewTab ? '_blank' : null}
      rel={openInNewTab ? 'nofollow noopener' : null}
      tabIndex={tabindex}
      onClick={onClick}
    >
      {leftIconName && (
        <span className="link-button__icon-holder link-button__icon-holder_left">
          <Icon name={leftIconName} className="link-button__icon " />
        </span>
      )}
      <span className="link-button__text">{text}</span>
      {iconName && (
        <span className="link-button__icon-holder">
          <Icon name={iconName} className="link-button__icon" />
        </span>
      )}
    </RootTag>
  );
};

LinkButton.viewModelMeta = {
  className: 'ignore',
  tabindex: 'ignore',
  size: 'ignore',
  isActive: 'ignore',
  leftIconName: 'ignore',
  iconName: 'ignore',
  theme: 'ignore',
};

LinkButton.propTypes = Object.assign({}, LinkBase.propTypes, {
  className: PropTypes.string,
  tabindex: PropTypes.number,
  size: PropTypes.oneOf(Object.values(sizes)),
  isActive: PropTypes.bool,
  iconName: PropTypes.string,
  leftIconName: PropTypes.string,
  theme: PropTypes.oneOf(Object.values(themes)),
});

// eslint-disable-next-line view-models/no-errors
export default LinkButton;
